<template>
  <div class="card mb-4" id="badges">
    <div class="card-header">
      <h3>Badges</h3>
    </div>
    <div class="card-body">
      <h4>Normal badge</h4>
      <div class="mb-3">
        <span class="badge badge-primary">NEW</span>
      </div>
      <pre>&lt;span class="badge badge-primary" /&gt;1&lt;/&gt;</pre>

      <div class="pt-3 d-flex flex-wrap">
        <div>
          <span class="badge badge-primary">primary</span>
        </div>
        <div>
          <span class="badge badge-secondary">secondary</span>
        </div>
        <div>
          <span class="badge badge-success">success</span>
        </div>
        <div>
          <span class="badge badge-warning">warning</span>
        </div>
        <div>
          <span class="badge badge-danger">danger</span>
        </div>
        <div>
          <span class="badge badge-info">info</span>
        </div>
        <div>
          <span class="badge badge-light">light</span>
        </div>
        <div>
          <span class="badge badge-dark">dark</span>
        </div>
        <div>
          <span class="badge badge-color-1">color 1</span>
        </div>
        <div>
          <span class="badge badge-color-2">color 2</span>
        </div>
        <div>
          <span class="badge badge-color-3">color 3</span>
        </div>
        <div>
          <span class="badge badge-color-4">color 4</span>
        </div>
      </div>

      <hr />

      <h4>Circle badge</h4>
      <div class="mb-3">
        <span class="badge badge-circle">1</span>
      </div>
      <pre>&lt;span class="badge badge-circle" /&gt;1&lt;/&gt;</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: "Badges",
};
</script>
